export default "__VITE_ASSET__BrQOBvPY__"